import { AvForm } from "availity-reactstrap-validation"
import { CustomDatePicker } from "components/Common"
import { convertDateFormat } from "helpers/utilities"
import React from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"

const DeliveryReceiptTableButtons = ({
  model, onChange, onSubmit, t
}) => {

  return (
    <React.Fragment>
      <AvForm>
        <div className="d-flex">
          <div style={{ marginLeft: '5px' }}>
            <CustomDatePicker
              conjunction=" - "
              name="requestDate"
              label={""}
              checkSameTime={true}
              format={"d-m-Y"}
              dateFormat='d-m-Y'
              value={[convertDateFormat(model.start || new Date(), "DD-MM-YYYY"), convertDateFormat(model.end || new Date(), "DD-MM-YYYY")]}
              closeOnSelect={true}
              onKeyDown={e => {
                if (e.keyCode == 13) {
                  onSubmit && onSubmit()
                }
              }}
              onChangeHandler={date => {
                if (date.time.length == 2) {
                  onChange({
                    start: convertDateFormat(date.time[0], "YYYY-MM-DD"),
                    end: convertDateFormat(date.time[1], "YYYY-MM-DD"),
                  })
                }
                else {
                  onChange({
                    start: convertDateFormat(new Date(), "YYYY-MM-DD"),
                    end: convertDateFormat(new Date(), "YYYY-MM-DD"),
                  })
                }
              }}
              maxDate={new Date()}
              mode="range"
            />
          </div>
        </div>
      </AvForm>
    </React.Fragment>
  )
}

const mapStateToProps = ({ hisConnector }) => ({

})

const mapDispatchToProps = dispatch => ({

})

DeliveryReceiptTableButtons.displayName = 'DeliveryReceiptTableButtons';
export default withTranslation(["testRequestPage", "common", "button"], { withRef: true })(connect(
  mapStateToProps,
  mapDispatchToProps, null, { forwardRef: true }
)(DeliveryReceiptTableButtons))
